import {Component, NgZone, OnInit, Renderer2} from '@angular/core';
import {ListSearchParams} from '../../shared/Models/listsearchparams.model';
import {ListComponent} from '../../iwgcommon/list/list.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Utils} from '../../shared/utils/utils';
import {UserService} from '../../shared/services/user.service';
import {NavbarService} from '../../shared/services/navbar.service';
import {GlobalConstants} from '../../iwgcommon/global-constants';
import {DocumentsService} from '../../shared/services/documents.service';

@Component({
  selector: 'app-documents-table',
  templateUrl: './documents-table.component.html',
  styleUrls: ['./documents-table.component.scss']
})
export class DocumentsTableComponent extends ListComponent implements OnInit {

  state: ListSearchParams;

  allowEndClients = false;
  USEORDisabled = false;
  selectedService = 1;
  USComplianceDisabled = false;
  USAORDisabled = false;
  InternationalEORDisabled = false;
  InternationalComplianceDisabled = false;
  InternationalAORDisabled = false;
  ShowEngageButton = false;
  showCompliance = false;
  labelSingular = '';
  AssignmentGUID: any;
  AssignmentId: any;
  ContractorName: any;
  globalScopes: any;
  BussinessName: any;
  documentsId: any;
  AssignmentStatusId: any;
  hideColsInExport: number[];
  lastColIndex = 12;
  constructor(private router: Router, utils: Utils, userService: UserService,
              public nav: NavbarService, renderer: Renderer2, public route: ActivatedRoute,
              documentsService: DocumentsService, zone: NgZone) {
    super(documentsService, utils, renderer, userService, zone);
    this.globalScopes = GlobalConstants.globalScopes;
  }
  ngOnInit(): void {
    this.state = {limit: 25, page: 1, service: 1, global_scope: 1, country: -1};
    this.allowEndClients = this.userService.getAllowEndClients();
    this.route.queryParams.subscribe(params => {
      this.documentsId = params.ID;      
      if (params) {
        this.selectedService = +params.service;

        this.state = Object.assign({}, this.state, (params));
        if (!this.state.service) {
          this.state.service = 1;
        }
        if (params.start) {
          this.state.start = new Date(params.start);
        }
        if (params.end) {
          this.state.end = new Date(params.end);
        }

      }
    });
  }

}
